import React, { useEffect, useState } from "react";
import Backdrop from "@mui/material/Backdrop";
import Modal from "@mui/material/Modal";
import "./productquantitymodal.css";
import { productQuantity } from "../../../../services/product.service";
import CircularLoader from "../../../../Components/CircularLoader/CircularLoader";
import Form from "react-bootstrap/Form";
import Tooltips from "@mui/material/Tooltip";
import { IoIosAdd, IoIosRemove } from "react-icons/io";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

export default function WarehouseProductQty({
  open,
  setOpen,
  setProducts,
  setSnack,
  setProdHistoryModal,
}) {
  const { t } = useTranslation(["inventory", "common"]);
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [changed, setchanged] = useState(false);

  const handleFieldChange = (e) => {
    const { name, value } = e.target;
    setData((prevData) => ({
      ...prevData,
      [name]: value,
      ...(name === "adjQuantity" && {
        quantity: (
          Number(value) + Number(open?.row?.product_warehouse[0]?.quantity)
        ).toString(),
      }),
    }));
  };

  const handleSave = async () => {
    try {
      setLoading(true);
      const response = await productQuantity([
        {
          id: data?.id,
          quantity: data?.quantity,
          notes: data?.notes,
        },
      ]);
      if (!response.error) {
        setProducts((prevProducts) => {
          return {
            ...prevProducts,
            data: prevProducts?.data?.map((product) => {
              if (product.id == open?.row?.product_warehouse[0]?.product_id) {
                return {
                  ...product,
                  product_warehouse: [
                    {
                      ...product?.product_warehouse[0],
                      quantity: data?.quantity,
                    },
                  ],
                };
              }
              return product;
            }),
          };
        });
        // setOpen(data);
        setSnack((snack) => {
          return {
            ...snack,
            open: true,
            text: response?.data?.message,
            severity: "success",
          };
        });
        setLoading(false);
        setProdHistoryModal(open);
        handleClose();
      } else {
        setSnack((snack) => {
          return {
            ...snack,
            open: true,
            text: response?.data?.message ?? t("common:messages.somethingWentWrong"),
            severity: "error",
          };
        });
        setLoading(false);
      }
    } catch (error) {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: error?.response?.data?.message || t("common:messages.somethingWentWrong"),
          severity: "error",
        };
      });
    }
  };

  const handleClose = () => {
    setOpen(false);
    setData({});
  };

  useEffect(() => {
    if (open) {
      const warehouseData = open?.row?.product_warehouse?.[0] || {};

      setData({
        id: warehouseData?.id,
        productId: open?.row?.id,
        quantity: warehouseData?.quantity,
        warehouse: warehouseData?.warehouse,
        expStock:
          Number(warehouseData?.grn_details_sum_quantity ?? 0) -
          Number(warehouseData?.grn_details_sum_received_quantity ?? 0),
        adjQuantity: "",
        notes: "",
      });
    }
  }, [open]);

  useEffect(() => {
    let hasChanges = false;
    if (
      parseInt(data?.quantity, 10) !==
        parseInt(open?.row?.product_warehouse[0]?.quantity, 10) ||
      data?.notes != ""
    ) {
      hasChanges = true;
    }

    setchanged(hasChanges);
  }, [data, open]);
  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <div className="prod__quantity_desc_modal ">
          <div className="prod__quantity_desc_modalheading">
            {t("productModals.productQuantityInWarehouse")}
          </div>
          <div className="product_quantity_box_line" />

          <div className="prod__quantity_desc_modalcontent">
            <div className={"product_quantity_box_wrapper"}>
              <div className={"product_quantity_box_active"}>
                <div className="product_quantity_box_innerwrapper">
                  <div>
                    <Form.Label className="prod__quantity_box_label">
                      {t("productModals.name")}
                    </Form.Label>
                    <div className={"product_quantity_box_name"}>
                      {data?.warehouse?.id} {data?.warehouse?.name ?? "-"}
                    </div>
                  </div>

                  <div className="product_quantity_box_adjquantity_wrapper">
                    <div className="product_quantity_box_button">
                      <Tooltips title={t("productModals.removeQuantity")} placement="top">
                        <a
                          type="button"
                          onClick={() =>
                            handleFieldChange({
                              target: {
                                name: "adjQuantity",
                                value: Number(data?.adjQuantity) - 1,
                              },
                            })
                          }
                        >
                          <IoIosRemove
                            size={25}
                            style={{
                              border: "2px solid var(--color-brand-light)",
                              borderRadius: "25%",
                              marginLeft: "5px",
                            }}
                            className="p-1 overlaybtn"
                          />
                        </a>
                      </Tooltips>
                    </div>

                    <div>
                      <Form.Label className="prod__quantity_box_label">
                        {t("productModals.adjustedBy")}
                      </Form.Label>
                      <Form.Control
                        type="number"
                        className="product_quantity_box_adj_input"
                        value={Number(data?.adjQuantity)}
                        placeholder={t("productModals.adjustedBy")}
                        name="adjQuantity"
                        onChange={(e) => handleFieldChange(e)}
                      />
                    </div>
                    <div className="product_quantity_box_button">
                      <Tooltips title={t("productModals.addQuantity")} placement="top">
                        <a
                          type="button"
                          onClick={() =>
                            handleFieldChange({
                              target: {
                                name: "adjQuantity",
                                value: Number(data?.adjQuantity) + 1,
                              },
                            })
                          }
                        >
                          <IoIosAdd
                            size={25}
                            style={{
                              border: "2px solid var(--color-brand-light)",
                              borderRadius: "25%",
                              marginRight: "5px",
                            }}
                            className="p-1 overlaybtn"
                          />
                        </a>
                      </Tooltips>
                    </div>
                  </div>

                  <div>
                    <Form.Label className="prod__quantity_box_label">
                      {t("productModals.new")}
                    </Form.Label>
                    <div className="product_quantity_box_newquantitybox_wrapper">
                      <div
                        className="product_quantity_box_newquantitybox"
                        style={{
                          color:
                            Number(data?.adjQuantity) +
                              Number(data?.quantity) >=
                            Number(data?.quantity)
                              ? "blue"
                              : "red",
                        }}
                      >
                        {Number(data?.quantity)}
                      </div>
                      {Number(data?.adjQuantity) != 0 && (
                        <div className="product_quantity_box_newquantitybox">
                          <span className="product_quantity_box_actualquantity">
                            {Number(data?.quantity) - Number(data?.adjQuantity)}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>

                  <div>
                    <Form.Label className="prod__quantity_box_label">
                      {t("productModals.expectedStock")}
                    </Form.Label>
                    <div className={"product_quantity_box_name"}>
                      {data?.expectedStock != 0 ? (
                        <span className="text-state-success-text">{data?.expStock}</span>
                      ) : (
                        0
                      )}
                    </div>
                  </div>
                </div>
                <div className="product_quantity_box_line" />
                <div className="product_quantity_box_innerwrapper">
                  <div className="product_quantity_box_reason_wrapper">
                    <label>{t("productModals.reason")}</label>
                    <textarea
                      type="text"
                      className="product_quantity_box_textarea"
                      value={data?.notes}
                      placeholder={t("productModals.reason")}
                      name="notes"
                      onChange={(e) => handleFieldChange(e)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="prod__quantity_desc_modalfooter">
            <div
              className="prod__quantity_desc_modalcncl"
              onClick={handleClose}
            >
              {t("common:actions.close")}
            </div>
            {changed && (
              <Button
                disabled={loading}
                className="product_quantity_box_modalsave"
                onClick={handleSave}
              >
                {loading ? <CircularLoader /> : t("common:actions.save")}
              </Button>
            )}
          </div>
        </div>
      </Modal>
    </div>
  );
}
